<template>
  <div class="generalPage">
    <div class="isotopeGrid">

      <div class="section1">
        <div class="title_wrapper">
          <p class="title">
            銷售地點
          </p>
          <p class="subTitle">
            威滅產品銷售地點
          </p>
        </div>
      </div>

      <div class="section2">
        <div class="generalWrapper">

          <!-- <div class="tab tabChannel" :class="{active: tabIndex === 0}"> -->
          <div class="tab tabChannel">
            <div class="tabTitle">
              威滅產品於下列商戶有售
            </div>
            
            <div class="shoplist_table_grid 2init_4">
              <div class="shoplist_table_rowgroup header">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader"></div>
                  <div class="shoplist_table_column column_1">
                    <a class="product_img" v-on:click="jumpToCockroach(1)"><img src="../assets/productCockroach-section3-product-1.png"></a>
                    <p>速效曱甴藥餌</p>
                  </div>
                  <div class="shoplist_table_column column_2">
                    <router-link to="/product/ant" class="product_img"><img src="../assets/productAnt-section2-overlay-nobadge.png"></router-link>
                    <p>速效殺蟻藥餌</p>
                  </div>
                  <div class="shoplist_table_column column_3">
                    <router-link to="/product/cockroach" class="product_img"><img src="../assets/productCockroach-section2-1.png"></router-link>
                    <p>速效曱甴藥餌<nobr>(典雅版)</nobr></p>
                  </div>
                  <div class="shoplist_table_column column_4">
                    <a class="product_img" v-on:click="jumpToCockroach(2)"><img src="../assets/productCockroach-sectionGel-product.png"></a>
                    <p>專業強效曱甴<nobr>凝膠餌劑</nobr></p>
                  </div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_welcome">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">惠康超級市場</div>
                      <div class="shopInfo">
                        <a href="https://www.wellcome.com.hk/zh-hant/our-store" target="_blank">
                          <img class="shopLogo" src="../assets/welcome.jpg"/>
                          <!-- <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/> -->
                        </a>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_4"><img class="icon-done" src="../assets/icon-done.svg"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_parknshop">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">百佳超級市場</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/parkinShop.png"/>
                        <a href="https://www.pns.hk/zh-hk/all-brands/b/103679/%E5%A8%81%E6%BB%85" target="_blank">
                          <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                        </a>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_4"><img class="icon-done" src="../assets/icon-done.svg"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_vanguard">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">華潤萬家*</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/vanguard.jpg"/>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"></div>
                  <div class="shoplist_table_column column_3"></div>
                  <div class="shoplist_table_column column_4"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_uselect">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">U-Select*</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/uselect.png"/>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"></div>
                  <div class="shoplist_table_column column_3"></div>
                  <div class="shoplist_table_column column_4"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_aeon">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">AEON</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/aeon.jpg"/>
                        <a href="https://www.aeoncity.com.hk/kh_zh/non-food/householdgoods/003052610.html" target="_blank">
                          <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                        </a>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"></div>
                  <div class="shoplist_table_column column_4"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_yata">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">一田 YATA</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/yata.jpg"/>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_4"><img class="icon-done" src="../assets/icon-done.svg"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_unyapita">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">UNY / APITA</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/apita.jpg"/>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_4"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_bamboos">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">百本旺角市集</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/bamboos.png"/>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_4"><img class="icon-done" src="../assets/icon-done.svg"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_hktvmall">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">HKTV mall</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/hktvMall.jpg"/>
                        <a href="https://www.hktvmall.com/hktv/zh/main/search?page=0&q=%3Arelevance%3Acategory%3AAA11824000001%3Azone%3Asupermarket%3Abrand%3ACombat%3Astreet%3Amain%3A" target="_blank">
                          <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                        </a>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_4"><img class="icon-done" src="../assets/icon-done.svg"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_ztore">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">Ztore 士多</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/ztore.jpg"/>
                        <a href="https://www.ztore.com/tc/search/combat" target="_blank">
                          <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                        </a>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"></div>
                  <div class="shoplist_table_column column_4"><img class="icon-done" src="../assets/icon-done.svg"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_pandamart">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">PandaMart</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/pandamart.jpg"/>
                        <a href="https://www.foodpanda.hk/groceries#all-pandamarts" target="_blank">
                          <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                        </a>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_4"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_homeplus">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">HOMEPLUS</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/homeplus.jpg"/>
                        <a href="https://www.home-plus.hk/tc_hk/products?brand=17504" target="_blank">
                          <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                        </a>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_4"><img class="icon-done" src="../assets/icon-done.svg"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_healthstore">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">HealthStore</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/healthstore.jpg"/>
                        <a href="https://www.healthstore.com.hk/collections/combat-威滅?utm_source=combat&utm_medium=referral&utm_campaign=brandsite" target="_blank">
                          <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                        </a>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_4"><img class="icon-done" src="../assets/icon-done.svg"></div>
                </div>
              </div>

              <div class="shoplist_table_rowgroup data shop_pharmacy">
                <div class="shoplist_table_row">
                  <div class="shoplist_table_rowheader">

                    <div class="shoplist">
                      <div class="shopName">各大藥行藥房</div>
                      <div class="shopInfo">
                        <img class="shopLogo" src="../assets/all_pharmacy.jpg"/>
                        <a href="https://docs.google.com/spreadsheets/d/1038226dN2l4fc_kwaJjAP6E5yiUBQNLo/edit?usp=sharing&ouid=109814576360705695639&rtpof=true&sd=true" target="_blank">
                          <img class="shoplinkBtn" src="../assets/btn-pharmacylist.png"/>
                        </a>
                      </div>
                    </div>

                  </div>
                  <div class="shoplist_table_column column_1"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_2"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_3"><img class="icon-done" src="../assets/icon-done.svg"></div>
                  <div class="shoplist_table_column column_4"><img class="icon-done" src="../assets/icon-done.svg"></div>
                </div>
              </div>

              <div class="shoplist_table_notice">
                <p>*部分產品只限指定門市有售貨</p>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>
    <contact></contact>
    <henkel-footer></henkel-footer>
  </div>
</template>

<script>
export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  },
  methods: {
    jumpToCockroach (target) {
      this.$root.switchCockroach = 1
      this.$root.switchCockroachTarget = target
      this.$router.push({path: 'product/cockroach'})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../styles/_vars.sass"
@import "../styles/_isotopeGrid.sass"

body
  overflow-x: unset

.generalPage
  padding-top: $topMenu-height

  .img
    float: right
    width: 372px
    width: 30%
    margin: 0 0 18px 0
    text-align: center

    @media only screen and (max-width: 959px)
      width: 100%

    img
      float: none !important
      width: 100% !important

      @media only screen and (max-width: 959px)
        width: 50% !important

      @media only screen and (max-width: 959px)
        width: 70% !important

  .txt_group
    display: block
    float: left
    width: 67%
    margin-bottom: 18px

    @media only screen and (max-width: 959px)
      width: 100%

  .clear
    clear: both

  .isotopeGrid
    .section2
      overflow: unset

      img
        float: unset

  .tab
    // display: none


    // ---- start of shoplist_table ----
    
    .shoplist_table_grid
      width: 100%

      .icon-done
        width: auto

    .shoplist_table_rowgroup
      width: 100%
      position: relative
      margin-bottom: 1rem

      &.header
        position: sticky
        top: 55px
        z-index: 1
        background-color: white
        margin-left: -18px;
        width: calc(100% + 36px);
        padding: 0 18px;

        .shoplist_table_rowheader
          display: none
          @media only screen and (min-width: 1320px)
            display: unset
            grid-column: inherit

      &.data
        // border-top: 2px solid #bfbfbf
        border-bottom: 2px solid #bfbfbf
        padding-top: 1em
        padding-bottom: .5em

        @media only screen and (min-width: 1320px)
          padding-bottom: 1.5em

      &.package
        img
          margin-bottom: 1em
          width: 80%
          max-width: 168px

      &.shape
        img
          margin-bottom: 1em
          width: 80%
          max-width: 168px

      &.shop_welcome
        .shopLogo
          height: 40px

          @media only screen and (max-width: 479px)
            height: 30px

      &.shop_parknshop
        .shopLogo
          height: 40px

          @media only screen and (max-width: 479px)
            height: 30px

      &.shop_vanguard
        .shopLogo
          height: 80px

          @media only screen and (max-width: 479px)
            height: 60px

      &.shop_uselect
        .shopLogo
          height: 55px

          @media only screen and (max-width: 479px)
            height: 41px

      &.shop_aeon
        .shopLogo
          height: 46px

          @media only screen and (max-width: 479px)
            height: 34px

      &.shop_yata
        .shopLogo
          height: 55px

          @media only screen and (max-width: 479px)
            height: 41px

      &.shop_unyapita
        .shopLogo
          height: 67px

          @media only screen and (max-width: 479px)
            height: 41px

      &.shop_bamboos
        .shopLogo
          height: 100px

          @media only screen and (max-width: 479px)
            height: 75px

      &.shop_hktvmall
        .shopLogo
          height: 50px

          @media only screen and (max-width: 479px)
            height: 37px

      &.shop_ztore
        .shopLogo
          height: 60px

          @media only screen and (max-width: 479px)
            height: 45px

      &.shop_pandamart
        .shopLogo
          height: 50px

          @media only screen and (max-width: 479px)
            height: 37px

      &.shop_homeplus
        .shopLogo
          height: 70px

          @media only screen and (max-width: 479px)
            height: 37px

      &.shop_healthstore
        .shopLogo
          height: 50px

          @media only screen and (max-width: 479px)
            height: 37px

      &.shop_pharmacy
        .shopLogo
          height: 50px

          @media only screen and (max-width: 479px)
            height: 37px

    .shoplist_table_row
      // position: sticky
      // top: 100px
      display: grid
      --column-gap: 1%
      --columns: 4
      margin: 0 auto
      grid-template-columns: repeat(var(--columns), calc((100% - var(--column-gap) * (var(--columns) - 1))/var(--columns)))
      column-gap: var(--column-gap)

      @media only screen and (min-width: 1320px)
        --columns: 5
      
    .init_4
      .shoplist_table_row
        --columns: 4
      .shoplist_table_rowheader
        grid-column: 1/4 span

    .init_3
      .shoplist_table_row
        --columns: 3
      .shoplist_table_rowheader
        grid-column: 1/3 span

    .init_2
      .shoplist_table_row
        --columns: 2
      .shoplist_table_rowheader
        grid-column: 1/2 span

    .shoplist_table_rowheader
      width: 100%
      grid-column: 1/5 span
      text-transform: uppercase
      letter-spacing: .06em
      font-weight: 600
      border-bottom: 1px solid var(--sg-light-gray)

      @media only screen and (min-width: 1320px)
        grid-column: unset

      h3
        margin-bottom: 1rem

      .shoplist
        padding: 0
        
        .shopName
          font-size: 1.14em
          margin-bottom: .5em
          
        .shopInfo
          display: flex
          align-items: center
          flex-wrap: wrap

          .shopLogo
            width: unset
            margin-bottom: unset
            margin-right: 1em

          .shoplinkBtn
            width: unset

          @media only screen and (min-width: 1320px)
            .shopLogo
              margin-bottom: .5em

          @media only screen and (max-width: 479px)
            flex-direction: column
            align-items: flex-start

            .shopLogo
              margin-bottom: .5em

    .shoplist_table_column
      padding: .5rem 0 .5rem
      text-align: center
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center

      @media only screen and (min-width: 1320px)
        padding: 1.5rem 0 1.5rem

      .product_img
        width: 10vw
        height: 4vw
        max-width: 120px
        max-height: 70px
        min-width: 50px
        min-height: 29px
        margin-bottom: 1em
        display: flex
        align-items: center
        justify-content: center
        cursor: pointer

        @media only screen and (max-width: 768px)
          // width: 60px
          // height: 35px

        @media only screen and (max-width: 479px)
          // width: 40px
          // height: 23px

        img
          max-width: 100%
          max-height: 100%
          width: auto
          height: auto

      p
        line-height: 1.1em
        margin-bottom: 0

    .shoplist_table_img
      img
        width: 80%
        max-width: 200px

    .shoplist_table_selector
      position: relative

    .shoplist_table_selector_button
      position: relative
      width: 100%
      min-height: 50px
      display: flex
      justify-content: space-between
      align-items: center
      border: 1px solid var(--sg-light-gray)
      padding: .2rem .5rem
      margin-bottom: .5rem

    .shoplist_table_selector_button
      span
        text-align: left
        line-height: 1.1

    .shoplist_table_selector_arrow
      font-size: 16px

    .shoplist_table_selector_list
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      opacity: 0
      -webkit-appearance: none
      font-size: 16px

    .shoplist_table_notice
      width: 100%
      background-color: white
      padding: 1em

      p
        margin: 0

    // ---- end of shoplist_table ----

    .shoplistCol
      // overflow: auto
      // max-height: 60vh
      -webkit-overflow-scrolling: touch
      max-width: 1094px
      margin: 0 auto

      &::-webkit-scrollbar
        width: 5px
        background: transparent

      &::-webkit-scrollbar-thumb
        background: white
        border-radius: 20px

    &.tabChannel
      .shoplistCol
        // height: 45vh

        @media only screen and (max-width: 320px)
          // height: 50vh

        & > div:first-child
          @media only screen and (min-width: 768px)
            border-right: 2px solid #565656

          &.full
            border-right: 0
            margin: 0 auto

            .shoplist
              justify-content: center

            .shopInfo
              flex: unset
              max-width: unset
              width: unset

      .shoplist
        @media only screen and (max-width: 768px)
          padding: 25px !important
          border-bottom: 2px solid #565656
      
      .shoplist_table_rowheader
        .shoplist
          @media only screen and (max-width: 768px)
            padding: unset !important
            border-bottom: unset !important

    &.tabInfo
      .tabName
          margin-bottom: 30px

      .shoplist
        padding-left: 0 !important
        padding-right: 0 !important
        @media only screen and (max-width: 768px)
          padding-top: 0 !important
          padding-bottom: 5% !important

        img
          max-width: 25vw
          @media only screen and (max-width: 768px)
            max-width: none

        .logo2
          width: 100%
          max-width: 90%

        &.productContainer
          text-align: center

          .shopLogo
            margin-top: 10%
            width: 90%

            @media only screen and (max-width: 768px)
              margin-top: 0
      
    &.tabMethod
      .shoplistCol
        margin-top: 5%
        overflow: auto
        max-height: 60vh

        .shoplist
          padding-bottom: 10px

          .imageContainer
            text-align: center
            .shopLogo
              width: 120px
              height: 120px

              @media only screen and (max-width: 768px)
                width: 70%
                height: 70%

          .methodNum
            font-size: 40px
            font-weight: bold
            margin-top: -20px

          .shopName
            margin-top: 20px

            /deep/ ul
              list-style-type: disc

              li
                margin-left: 1.3em

        .methodList
          font-size: 14px
          list-style-type: decimal
          padding-left: 1em

          > li
            margin-bottom: 2em

            ul
              margin-top: 1em
              list-style-type: disc
              padding-left: 1em

              > li
                margin-bottom: .5em
                
    &.active
      display: block

    .tabName
      font-size: 24px
      @media only screen and (max-width: 768px)
        font-size: 18px

      img
        width: 47px
    
    .tabTitle
      width: 100%
      text-align: center
      font-size: 20px
      margin-top: 20px
      margin-bottom: 30px
    4
      @media only screen and (max-width: 768px)
        margin-top: 10%
        margin-bottom: 10%

    .shoplistCol
      .shoplist
        padding-left: 0
        padding-right: 0
        font-size: 14px
        padding-bottom: 20px

        @media only screen and (max-width: 768px)
          padding-bottom: 25px
          padding-top: 25px

        .shopLogo
          width: 100%
          margin-bottom: 10px

        .shopInfo
          // margin-top: 10px
          overflow: hidden

          .shopName
            float: left
            padding-top: 5px

          .shoplinkBtn
            float: left
            width: 85px
            margin-top: 3px
            margin-left: 10px

    &.tabWorks
      .shoplistCol
        .shoplist
          padding: 0
          padding-top: 3%
          font-size: 14px
          
          .imageContainer
            text-align: center
            .shopLogo
              width: 90%

          .methodNum
            font-size: 40px
            font-weight: bold
            margin-top: 20px

          .shopName
            margin-top: 20px

            a
              color: white




</style>



// WEBPACK FOOTER //
// Shoplist.vue?1b5f4057